import { Component, ContentChild, EventEmitter, forwardRef, HostBinding, Inject, Input, OnChanges, OnDestroy, Optional, Output, SimpleChanges, TemplateRef } from "@angular/core";
import "./v-tab.component.scss";
import { VTabsComponent, VTabStepperState } from "./v-tabs.component";

@Component({
    selector: 'v-tab',
    template: require("./v-tab.component.html"),
})
export class VTabComponent implements OnChanges, OnDestroy {

    @Input() tabTitle: string;
    @Input() tabId: string;
    @Input() icon: string;
    @Input() iconClass: string;
    @Input() count: number;
    @Input() order: number;

    @Input() stepperComplete: boolean;
    @Input() disabled: boolean;
    @Input() disableNext: boolean;
    @Input() disablePrev: boolean;
    @Input() nextLabel: string = "Next";
    @Input() nextIcon: string = "chevron_right";

    @Input() hideIfNoData: boolean;
    @Input() hide: boolean;
    @Input() selected: any;
    @Input() hideOnMobile: boolean;

    @Input() error: boolean;

    @Output() onTabSelected: EventEmitter<any> = new EventEmitter();

    // used in angular only - https://stackoverflow.com/questions/41453727/is-it-possible-to-prevent-child-components-from-being-created-if-ng-content-is-n
    @Input() @ContentChild("template", { read: TemplateRef }) templateRef!: TemplateRef<any>;

    // ---

    @HostBinding("hidden") private hidden = true;
    stepperState = VTabStepperState.Todo;
    tabIndex: number;

    clickable = true;

    constructor(@Optional() @Inject(forwardRef(() => VTabsComponent)) private parent: VTabsComponent) {
    }

    ngOnInit(): void {
        if (this.hide) {
            return;
        }

        this.parent.registerTab(this);
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["stepperComplete"] && this.stepperComplete) {
            this.stepperState = VTabStepperState.Complete;
            this.parent.onTabStepperStateChanged(this);
        }

        if (changes["selected"] && this.selected) {
            this.parent.selectTab(this);
        }
    }

    ngOnDestroy(): void {
        this.parent.tabs = this.parent.tabs.filter(t => t != this);
        this.parent.unregisterTab(this);
    }

    showTab(): void {
        this.hidden = false;
        this.onTabSelected.emit();
    }

    hideTab(): void {
        this.hidden = true;
    }
}
